import { Routes } from '@angular/router';
import { GenericErrorComponent } from './generic-error/generic-error.component';


export const routes: Routes = [
  {
    path: 'error',
    component: GenericErrorComponent
  }
];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/shared.routes.ts